import React, { useState, useRef, useEffect } from "react";
import JoditEditor from "jodit-react";
import { getContentApi, updateContentApi } from "services/cms";
import { toastMessage } from "utils/toastMessage";
import { CustomModal } from "components/modals/ModalBox";
import "./ContentManagement.scss";
import useButtonLoader from "hooks/useButtonLoader";
import useFullPageLoader from "common/UseFullPageLoader";

import { FaPencilAlt, FaPlus } from "react-icons/fa";
import useUser from "hooks/useUser";

// -content management tab

import ContentManagementTabs from "./ContentManagementTabs";

const ContentManagement = () => {
  const editor = useRef(null);
  const { havePermission } = useUser();
  const [contentData, setContentData] = useState({});
  const [selectedKey, setSelectedKey] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editorContent, setEditorContent] = useState("");
  const [buttonLoader, setButtonLoader] = useButtonLoader("Save");
  const [loader, onShow, onHide] = useFullPageLoader();

  // user selected language
  const [propertyTab, setPropertyTab] = useState("en");
  console.log("selected language:--->", propertyTab);

  // Predefined content types
  const keys = [
    { key: "ABOUT-US", label: "About Us" },
    { key: "TERMS", label: "Terms & Conditions" },
    { key: "PRIVACY", label: "Privacy Policy" },
  ];

  // fetch cms detail
  const fetchContent = async () => {
    try {
      onShow();
      const { data, status } = await getContentApi(propertyTab);

      if (status === 200) {
        const result = data?.data?.reduce((acc, { type, description }) => {
          acc[type] = description;
          return acc;
        }, {});

        setContentData(result);
      }
    } catch (error) {
      console.error("Error fetching content:", error.message);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchContent();
  }, [propertyTab]);

  // Open the modal and set the content for the selected key
  const openEditor = (key) => {
    setSelectedKey(key);
    setEditorContent(contentData[key] || "");
    setIsModalOpen(true);
  };

  // userRole, type, description
  // // Handle content update
  const updateContent = async () => {
    setButtonLoader(true);
    try {
      const reqData = {
        type: selectedKey,
        description: editorContent,
        language: propertyTab,
      };
      const { data, status } = await updateContentApi(reqData);
      if (status === 200) {
        toastMessage(data?.message, "success", "contentUpdate");
        setContentData((prev) => ({ ...prev, [selectedKey]: editorContent }));
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Error updating content:", error.message);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <div className="content_management">
        <div className="dashboard_title">
          <h3>Content Management</h3>
        </div>
        {/* -----------ContentManagementTabs */}
        <ContentManagementTabs
          setPropertyTab={setPropertyTab}
          propertyTab={propertyTab}
        />
        <div className="card">
          <div className="card-body">
            <div className="contentManagement">
              <div className="content-grid">
                {loader}
                {keys.map(({ key, label }) => (
                  <div key={key} className="content-card">
                    <h4>{label}</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: contentData[key] || "No content available",
                      }}
                    />
                    {havePermission("content.write") && (
                      <button
                        className="edit-button"
                        onClick={() => openEditor(key)}
                      >
                        {contentData[key] ? (
                          <>
                            <FaPencilAlt />
                            Edit
                          </>
                        ) : (
                          <>
                            <FaPlus /> Add
                          </>
                        )}
                      </button>
                    )}
                  </div>
                ))}
              </div>
              {/* Custom Modal for editing or adding content */}
              <CustomModal
                show={isModalOpen}
                handleClose={() => setIsModalOpen(false)}
                className="lg edit_content_modal"
                size="lg"
              >
                <h3>
                  {contentData[selectedKey]
                    ? `Edit ${
                        keys.find((item) => item.key === selectedKey)?.label
                      }`
                    : `Add ${
                        keys.find((item) => item.key === selectedKey)?.label
                      }`}
                </h3>
                <JoditEditor
                  ref={editor}
                  value={editorContent}
                  tabIndex={1}
                  onBlur={(newContent) => setEditorContent(newContent)}
                  config={{
                    readonly: false,
                    height: 300,
                    placeholder: "Edit content here...",
                  }}
                />
                <div className="button_wrap">
                  <button
                    type="button"
                    className="button light"
                    onClick={() => setIsModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="button"
                    onClick={updateContent}
                    ref={buttonLoader}
                  >
                    Save
                  </button>
                </div>
              </CustomModal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentManagement;
